
let recaptchaReady = false

async function waitForGrecaptchaReady(timeoutMs = 30000) {
  if (typeof window === 'undefined') throw new Error('recaptcha: window is undefined')
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V3
  if (!siteKey) throw new Error('recaptcha: NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V3 is not set')

  if (recaptchaReady) return

  return new Promise((resolve, reject) => {
  // wait for grecaptcha.ready to become available
    const overall = setTimeout(() => {
      const msg = 'reCAPTCHA not available; ensure the script is included: https://www.google.com/recaptcha/api.js?render=SITE_KEY'
      console.error('recaptcha:', msg)
      reject(new Error(msg))
    }, timeoutMs)

    const check = () => {
      if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') {
        try {
          window.grecaptcha.ready(() => {
            clearTimeout(overall)
            recaptchaReady = true
            resolve()
          })
        } catch (e) {
          clearTimeout(overall)
          console.error('recaptcha: error during grecaptcha.ready', e)
          reject(e)
        }
      } else {
        setTimeout(check, 100)
      }
    }

    check()
  })
}

function withTimeout(promise, timeoutMs = 30000) {
  return new Promise((resolve, reject) => {
    const t = setTimeout(() => reject(new Error('reCAPTCHA process timeout')), timeoutMs)
    promise
      .then(r => {
        clearTimeout(t)
        resolve(r)
      })
      .catch(err => {
        clearTimeout(t)
        reject(err)
      })
  })
}

export async function getRecaptchaV3Token(action = 'submit') {
  await waitForGrecaptchaReady()
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V3

  return withTimeout(
    new Promise((resolve, reject) => {
      try {
        const exec = window.grecaptcha.execute(siteKey, { action })
        if (exec && typeof exec.then === 'function') {
          exec
            .then(token => resolve(token))
            .catch(err => {
              console.error('recaptcha: grecaptcha.execute promise rejected', err)
              reject(err)
            })
        } else {
          const err = new Error('reCAPTCHA v3 execute is not returning a promise')
          console.error('recaptcha:', err)
          reject(err)
        }
      } catch (err) {
        console.error('recaptcha: exception while calling grecaptcha.execute', err)
        reject(err)
      }
    })
  )
}
